const apiEnpoint =
  process.env.REACT_APP_API_URL || "https://salonium.pro/"

export default apiEnpoint.endsWith("/") ? apiEnpoint : `${apiEnpoint}/`
